// Perceived luminance of a hex colour, 0 (black) → 1 (white).
export const hexLuminance = (hex) => {
  const m = /#?([0-9a-fA-F]{6}|[0-9a-fA-F]{3})/.exec(hex || "");
  if (!m) return 1; // treat unknown as "too light" so it fails the dark check
  let h = m[1];
  if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
};

// Facility colours are used as dark text on a light tint of themselves, so they
// must be dark enough to stay readable. Anything above this threshold (pastels,
// near-whites) is rejected in the picker.
export const DARK_THRESHOLD = 0.6;

export const isDarkColor = (hex) => hexLuminance(hex) < DARK_THRESHOLD;
